var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import { TableComponent } from "../TableComponent";
import { EGamePhase, EGameStatus, } from "../../../types";
import { useAppDispatch, useAppSelector } from "../../../hooks";
import { selectMatchState, selectShowRoles, setMatchState, toggleShowRoles, } from "../../../store/match";
import { Delimiter } from "../../atoms/Delimiter";
import { VotesList } from "../VotesList";
import { ModalNew } from "../../atoms/Modal/Modal";
import { PlayerActions } from "../PlayerActions";
import * as api from "../../../api/matches";
import { getIntroductionThemes } from "../../../api/matches";
import { confirmPlayerPass } from "../../../api";
import { ModalWrapperNew } from "../../atoms/ModalWrapper/ModalWrapper";
import { MatchEnd } from "../../../pages/MatchEnd";
import { useAlerts } from "../../molecules/Alerts";
import { getAlertSuccess, getMafiaErrors } from "../../../utils";
import ReturnIco from "../../../../public/img/back-icon.svg";
import { useErrorHandler } from "../../../hooks/useErrorHandler";
import { DeskFooterComponent } from "../DeskFooterComponent";
import { GameButton } from "../../atoms/GameButton";
import TvIcon from "@mui/icons-material/Tv";
import FullscreenIcon from "@mui/icons-material/Fullscreen";
import { Portal } from "../../atoms/Portal/Portal";
import { colors } from "../../../styles/colors";
import { ScreenPairDialog } from "../../../features/screenPairing";
const PlayersContainer = styled.div `
  position: relative;
  z-index: 30;
  display: flex;
  flex-direction: column;
`;
const Container = styled.div `
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 60px;
  overflow: hidden;
  height: 100vh;
  width: 100vw;
  min-width: 780px;
  min-height: 720px;
`;
const GameDesk = styled.div `
  position: relative;
  width: 838px;
  height: 100%;
  display: flex;
  //margin: 0 auto;
`;
const DeskWrapper = styled.div `
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  height: 100%;
  touch-action: none;
`;
const DeskHeader = styled.div `
  display: flex;
  justify-content: flex-end;
  align-items: center;
  position: absolute;
  width: calc(100% - 120px);
  z-index: 1000;
`;
const GameInfoContainer = styled.div `
  display: flex;
  flex-direction: column;
  margin-left: 30px;
  max-height: calc(100vh - 120px);
  min-width: 300px;
  overflow-y: auto;
`;
const ModalWrapper = styled(ModalWrapperNew) `
  align-items: flex-start;
  padding: 30px 30px 0;
  min-width: 527px;
`;
const ModalIntroductionWrapper = styled(ModalWrapperNew) `
  align-items: flex-start;
  padding: 30px;
  min-width: 527px;
`;
const ModalVotesWrapper = styled(ModalWrapperNew) `
  align-items: flex-start;
`;
const VotesButton = styled.div `
  display: flex;
  align-items: center;
`;
// Фикс-полоса с действиями ведущего в левом верхнем углу. Фиксированный
// контейнер и flex-ряд с gap, чтобы кнопки не слипались и не наезжали
// при любой ширине (820px, 1180px, 1920px).
const TopActions = styled.div `
  position: fixed;
  top: 5px;
  left: 5px;
  z-index: 100000;
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  max-width: calc(100vw - 10px);
`;
const TopActionButton = styled.button `
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 16px 12px 13px;
  text-transform: uppercase;
  font-weight: 500;
  font-family: 'Inter';
  font-size: 12px;
  color: ${colors.textPrimary};
  background-color: ${colors.surface};
  border-radius: 5px;
  border: 1px solid ${colors.primary};
  border-bottom: 3px solid ${colors.primary};
  cursor: pointer;
  transition: background-color 0.2s;
  white-space: nowrap;

  &:hover {
    background-color: ${colors.surfaceVariant};
  }
`;
const toggleFullscreen = () => {
    if (document.fullscreenElement) {
        document.exitFullscreen();
    }
    else {
        document.documentElement.requestFullscreen();
    }
};
export function MatchDesk({ players, onClickPlayerAction, gameButtonState, setCurrentPlayerId, addOnComponent, }) {
    var _a, _b, _c, _d;
    const { errorHandler } = useErrorHandler();
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const matchState = useAppSelector(selectMatchState);
    const showRoles = useAppSelector(selectShowRoles);
    const [selectedPlayer, setSelectedPlayer] = useState(null);
    const [selectedPlayers, setSelectedPlayers] = useState([]);
    const [viewVotes, setViewVotes] = useState(false);
    const [viewFouls, setViewFouls] = useState(false);
    const [viewIntroductionThemes, setViewIntroductionThemes] = useState(false);
    const [themesText, setThemesText] = useState("");
    const [themesLoading, setThemesLoading] = useState(false);
    const [viewEndGame, setViewEndGame] = useState(false);
    const [viewScreenPair, setViewScreenPair] = useState(false);
    const [isUndoLoading, setIsUndoLoading] = useState(false);
    const [isUndoUnavailable, setIsUndoUnavailable] = useState(false);
    const [isRequestSent, setIsRequestSent] = useState(false);
    const candidates = useMemo(() => (matchState === null || matchState === void 0 ? void 0 : matchState.state).candidates || [], [matchState]);
    const shooters = useMemo(() => { var _a, _b; return ((_b = (_a = matchState === null || matchState === void 0 ? void 0 : matchState.state) === null || _a === void 0 ? void 0 : _a.shootout) === null || _b === void 0 ? void 0 : _b.players) || []; }, [matchState]);
    const votes = useMemo(() => (matchState === null || matchState === void 0 ? void 0 : matchState.state).votes || [], [matchState]);
    const gameStatus = useMemo(() => matchState === null || matchState === void 0 ? void 0 : matchState.gameStatus, [matchState]);
    const { setAlerts } = useAlerts();
    useEffect(() => {
        setIsUndoUnavailable(false);
    }, [matchState === null || matchState === void 0 ? void 0 : matchState.updatedAt]);
    const getPlayer = (playerId) => matchState === null || matchState === void 0 ? void 0 : matchState.players.find((p) => p.id === playerId);
    const onPlayerClickInner = (playerId) => __awaiter(this, void 0, void 0, function* () {
        if (gameStatus === EGameStatus.MAFIA_MEETS) {
            return;
        }
        if (playerId === (selectedPlayer === null || selectedPlayer === void 0 ? void 0 : selectedPlayer.id)) {
            console.log(selectedPlayer);
            setSelectedPlayer(null);
        }
        if (selectedPlayers === null || selectedPlayers === void 0 ? void 0 : selectedPlayers.some((player) => (player === null || player === void 0 ? void 0 : player.id) === playerId)) {
            setSelectedPlayers(selectedPlayers.filter((player) => player.id !== playerId));
            yield (onClickPlayerAction === null || onClickPlayerAction === void 0 ? void 0 : onClickPlayerAction(""));
            return;
        }
        setSelectedPlayer(getPlayer(playerId) || null);
        const player = getPlayer(playerId);
        if (player &&
            selectedPlayers &&
            gameStatus === EGameStatus.GAME_ROLE_SETTING_NIGHT) {
            setSelectedPlayers([...selectedPlayers, player]);
        }
        else if (player &&
            selectedPlayers &&
            gameStatus !== EGameStatus.GAME_ROLE_SETTING_NIGHT) {
            setSelectedPlayers([player]);
        }
        yield (onClickPlayerAction === null || onClickPlayerAction === void 0 ? void 0 : onClickPlayerAction(playerId));
    });
    const onVotesOpen = () => {
        setViewVotes(true);
    };
    const onVotesClose = () => {
        setViewVotes(false);
    };
    const onFoulsClick = () => {
        setViewFouls(!viewFouls);
    };
    const onEndPageClick = () => {
        setViewEndGame(!viewEndGame);
    };
    const onChangeViewModeClick = () => {
        dispatch(toggleShowRoles());
    };
    const onChangeRole = () => {
        setSelectedPlayer(null);
        setSelectedPlayers([]);
    };
    const onPassButtonClick = () => __awaiter(this, void 0, void 0, function* () {
        var _e, _f;
        const currentVoteId = ((_e = matchState === null || matchState === void 0 ? void 0 : matchState.state) === null || _e === void 0 ? void 0 : _e.voteId) || "";
        const currentPlayer = (_f = matchState === null || matchState === void 0 ? void 0 : matchState.players) === null || _f === void 0 ? void 0 : _f.find((p) => { var _a; return p.id === ((_a = matchState === null || matchState === void 0 ? void 0 : matchState.state) === null || _a === void 0 ? void 0 : _a.currentPlayer); });
        if (currentPlayer === undefined) {
            return;
        }
        if (isRequestSent) {
            return;
        }
        try {
            setIsRequestSent(true);
            const result = yield confirmPlayerPass(currentVoteId, currentPlayer.id);
            // console.log('MatchDesk onStartGameClick', result)
            dispatch(setMatchState(result));
            setIsRequestSent(false);
        }
        catch (err) {
            errorHandler(err);
            console.error("MatchDesk onStartGameClick error", err.response);
            setIsRequestSent(false);
        }
    });
    const undoLastCommand = () => __awaiter(this, void 0, void 0, function* () {
        var _g;
        if (!(matchState === null || matchState === void 0 ? void 0 : matchState.id) || isUndoLoading || isUndoUnavailable)
            return;
        setIsUndoLoading(true);
        try {
            const result = yield api.undoLastAction(matchState === null || matchState === void 0 ? void 0 : matchState.id);
            if (!result) {
                setIsUndoLoading(false);
                return;
            }
            dispatch(setMatchState(result.match));
            const undoneLabel = result.undoneCommand.label || result.undoneCommand.commandType;
            setAlerts([getAlertSuccess(`Отменено: ${undoneLabel}`)]);
            setIsUndoLoading(false);
        }
        catch (e) {
            setIsUndoLoading(false);
            const status = (_g = e === null || e === void 0 ? void 0 : e.response) === null || _g === void 0 ? void 0 : _g.status;
            if (status === 422) {
                setIsUndoUnavailable(true);
            }
            setAlerts(getMafiaErrors(e));
        }
    });
    const getMatchState = () => __awaiter(this, void 0, void 0, function* () {
        if (!(matchState === null || matchState === void 0 ? void 0 : matchState.id))
            return;
        try {
            const result = yield api.getMatchState(matchState === null || matchState === void 0 ? void 0 : matchState.id);
            // console.log('Match getMatchState', result)
            dispatch(setMatchState(result));
            // dividePlayers(result.players)
        }
        catch (e) {
            console.error("Match getMatchState", e.response);
        }
    });
    const isSuggested = (playerId) => candidates.find((c) => c.id === playerId);
    const roundStarter = (playerId) => { var _a; return ((_a = matchState === null || matchState === void 0 ? void 0 : matchState.state) === null || _a === void 0 ? void 0 : _a.roundStarter) === playerId; };
    const isCurrentPlayer = (playerId) => { var _a; return ((_a = matchState === null || matchState === void 0 ? void 0 : matchState.state) === null || _a === void 0 ? void 0 : _a.currentPlayer) === playerId; };
    const votesCount = (playerId) => {
        const result = votes.find((c) => c.playerId === playerId);
        return (result === null || result === void 0 ? void 0 : result.votes) || 0;
    };
    const votingProcess = gameStatus === EGameStatus.PLAYER_VOTE_STATE ||
        gameStatus === EGameStatus.PLAYER_VOTING ||
        gameStatus === EGameStatus.SELECT_DIRECTION_OF_VOTE;
    const isResultPhase = gameStatus === EGameStatus.NIGHT_RESULT_SHOW_STATE ||
        gameStatus === EGameStatus.DAY_RESULT_SHOW_STATE;
    return (_jsxs(Container, Object.assign({ day: (matchState === null || matchState === void 0 ? void 0 : matchState.gamePhase) === EGamePhase.DAY }, { children: [_jsxs(DeskWrapper, { children: [_jsx(DeskHeader, {}), _jsxs(GameDesk, Object.assign({ day: (matchState === null || matchState === void 0 ? void 0 : matchState.gamePhase) === EGamePhase.DAY }, { children: [!isResultPhase && (_jsx(TableComponent, { day: (matchState === null || matchState === void 0 ? void 0 : matchState.gamePhase) === EGamePhase.DAY, players: players, onPlayerClickInner: onPlayerClickInner, selectedPlayer: selectedPlayer, selectedPlayers: selectedPlayers, addOnComponent: addOnComponent, onChangeRole: onChangeRole, onFoulsClick: onFoulsClick, voteItems: ((_a = matchState === null || matchState === void 0 ? void 0 : matchState.state) === null || _a === void 0 ? void 0 : _a.voteItems) || [] })), _jsx(GameInfoContainer, Object.assign({ day: (matchState === null || matchState === void 0 ? void 0 : matchState.gamePhase) === EGamePhase.DAY }, { children: (gameStatus === EGameStatus.SELECT_WHO_START_VOTING ||
                                    gameStatus === EGameStatus.PLAYER_VOTE_STATE ||
                                    gameStatus === EGameStatus.PLAYER_VOTING ||
                                    gameStatus === EGameStatus.SELECT_DIRECTION_OF_VOTE) && (_jsx(_Fragment, { children: _jsx(Delimiter, { top: "12px" }) })) }))] })), _jsx(DeskFooterComponent, { gameStatus: gameStatus, onFoulsClick: onFoulsClick, onPassButtonClick: onPassButtonClick, isRequestSent: isRequestSent, isThemesLoading: themesLoading, onChangeViewModeClick: onChangeViewModeClick, onThemesButtonClick: () => __awaiter(this, void 0, void 0, function* () {
                            // Open the popup immediately. If we already have themes, just show them.
                            setViewIntroductionThemes(true);
                            if (themesText) {
                                return;
                            }
                            try {
                                setThemesLoading(true);
                                const text = yield getIntroductionThemes();
                                setThemesText(text || "");
                            }
                            catch (e) {
                                console.error("Failed to load introduction themes", e);
                                setThemesText("Не удалось загрузить темы");
                            }
                            finally {
                                setThemesLoading(false);
                            }
                        }), onFixSeatingClick: () => {
                            navigate(`/match-config?matchId=${matchState === null || matchState === void 0 ? void 0 : matchState.id}&fixSeating=true`);
                        }, gameButtonState: gameButtonState, onVotesOpen: onVotesOpen, onEndPageClick: onEndPageClick }), _jsx(Portal, { children: _jsxs(TopActions, { children: [_jsx(TopActionButton, Object.assign({ type: "button", onClick: onEndPageClick }, { children: "\u0417\u0430\u0432\u0435\u0440\u0448\u0438\u0442\u044C \u0438\u0433\u0440\u0443" })), _jsxs(TopActionButton, Object.assign({ type: "button", onClick: toggleFullscreen }, { children: [_jsx(FullscreenIcon, { fontSize: "small" }), "\u041F\u043E\u043B\u043D\u043E\u044D\u043A\u0440\u0430\u043D\u043D\u044B\u0439 \u0440\u0435\u0436\u0438\u043C"] })), _jsxs(TopActionButton, Object.assign({ type: "button", onClick: () => setViewScreenPair(true) }, { children: [_jsx(TvIcon, { fontSize: "small" }), "\u042D\u043A\u0440\u0430\u043D"] }))] }) }), _jsx(GameButton, Object.assign({ className: "backButton", text: isUndoLoading ? "откат..." : "отменить действие", onClick: undoLastCommand, variant: { variant: "back" }, disabled: isUndoLoading || isUndoUnavailable }, { children: _jsx("img", { src: ReturnIco, alt: "undo last" }) }))] }), viewVotes && (_jsx(ModalNew, Object.assign({ close: true, onClose: onVotesClose }, { children: _jsx(ModalVotesWrapper, { children: _jsx(VotesList, { players: (matchState === null || matchState === void 0 ? void 0 : matchState.players) || [], votes: ((_b = matchState === null || matchState === void 0 ? void 0 : matchState.state) === null || _b === void 0 ? void 0 : _b.votes) || [], previousVote: ((_c = matchState === null || matchState === void 0 ? void 0 : matchState.state) === null || _c === void 0 ? void 0 : _c.previousVote) || null, voteItems: ((_d = matchState === null || matchState === void 0 ? void 0 : matchState.state) === null || _d === void 0 ? void 0 : _d.voteItems) || [], dayNumber: (matchState === null || matchState === void 0 ? void 0 : matchState.dayNumber) || 1 }) }) }))), viewFouls && (_jsx(ModalNew, Object.assign({ close: true, onClose: onFoulsClick }, { children: _jsx(ModalWrapper, { children: _jsx(PlayerActions, { players: (matchState === null || matchState === void 0 ? void 0 : matchState.players) || [], matchId: (matchState === null || matchState === void 0 ? void 0 : matchState.id) || "", reload: () => getMatchState() }) }) }))), viewEndGame && (_jsx(ModalNew, Object.assign({ close: true, onClose: onEndPageClick }, { children: _jsx(MatchEnd, {}) }))), _jsx(ScreenPairDialog, { open: viewScreenPair, onClose: () => setViewScreenPair(false), matchId: (matchState === null || matchState === void 0 ? void 0 : matchState.id) || null }), viewIntroductionThemes && (_jsx(ModalNew, Object.assign({ onClose: () => setViewIntroductionThemes(false) }, { children: _jsx(ModalIntroductionWrapper, { children: _jsxs("div", Object.assign({ style: { maxWidth: 640 } }, { children: [_jsxs("div", Object.assign({ style: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12, marginBottom: 8 } }, { children: [_jsx(Typography, Object.assign({ variant: "h6", sx: { color: '#fff' } }, { children: "\u0422\u0435\u043C\u044B \u043F\u0440\u0435\u0434\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u0438\u0439" })), _jsxs("div", Object.assign({ style: { display: 'flex', alignItems: 'center', gap: 8 } }, { children: [_jsx(Button, Object.assign({ variant: "outlined", size: "small", onClick: () => __awaiter(this, void 0, void 0, function* () {
                                                    try {
                                                        setThemesLoading(true);
                                                        const text = yield getIntroductionThemes();
                                                        setThemesText(text || "");
                                                    }
                                                    catch (e) {
                                                        console.error("Failed to refresh introduction themes", e);
                                                        setThemesText("Не удалось загрузить темы");
                                                    }
                                                    finally {
                                                        setThemesLoading(false);
                                                    }
                                                }), disabled: themesLoading, sx: { whiteSpace: 'nowrap' } }, { children: themesLoading ? 'Обновление…' : 'Обновить' })), _jsx(Button, Object.assign({ variant: "contained", color: "error", size: "small", onClick: () => setViewIntroductionThemes(false), sx: { whiteSpace: 'nowrap' } }, { children: "\u0417\u0430\u043A\u0440\u044B\u0442\u044C" }))] }))] })), _jsx(Typography, Object.assign({ variant: "body1", sx: { whiteSpace: 'pre-wrap', color: '#c8c8c8' } }, { children: themesLoading ? 'Загрузка…' : themesText || 'Темы не найдены' }))] })) }) })))] })));
}
